module.exports = __webpack_public_path__ + "img/wizard-instagram.3edd9188.png";